import { Component, PropTypes } from 'react'

export default class Idle extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isBrowser: (typeof window !== 'undefined'),
      isIdle: false, // Internal idle status
      timerId: null, // Id of the timer that was last created.
      timeout: props.timeout, // Times out after this many ms after last resetting action.
      onIdleStateChange: props.onIdleStateChange, // A function that's called when the idle state changes
      events: props.events || ['mousemove', 'keydown', 'wheel', 'DOMMouseScroll', 'mouseWheel', 'mousedown', 'touchstart', 'touchmove', 'MSPointerDown', 'MSPointerMove', 'click'],
      bindToElement: props.bindToElement // Event listeners will be bind to this element
    }

    // By default binds to document on browser.
    if (!this.state.bindToElement && this.state.isBrowser) {
      this.state.bindToElement = document
    }
  }

  componentDidUpdate (prevProps, prevState) {
    /**
     * When ever the internal idle state changes
     * we call the passed metohod with the is idle
     * value.
     */
    if (prevState.isIdle !== this.state.isIdle) {
      this.state.onIdleStateChange(this.state.isIdle)
    }
  }

  componentDidMount () {
    if (this.state.isBrowser) {
      this.startTimer()
      this.bindEvents()
    }
  }

  componentWillUnmount () {
    this.state.events.forEach(e => this.state.bindToElement.removeEventListener(e, this.resetTimer, false))
    this.deleteTimer()
  }

  startTimer = () => {
    let id = setTimeout(() => {
      this.setState({isIdle: true})
    }, this.state.timeout)
    this.setState({timerId: id})
  }

  resetTimer = () => {
    this.deleteTimer()
    this.startTimer()
  }

  deleteTimer = () => {
    this.setState({isIdle: false})
    clearTimeout(this.state.timerId)
  }

  bindEvents = () => {
    this.state.events.forEach(e => this.state.bindToElement.addEventListener(e, this.resetTimer, false))
  }

  render () {
    return false
  }
}

Idle.propTypes = {
  timeout: PropTypes.number.isRequired,
  onIdleStateChange: PropTypes.func.isRequired,
  events: PropTypes.arrayOf(PropTypes.string)
}



// WEBPACK FOOTER //
// ./src/Components/Idle/Idle.js